import { render, staticRenderFns } from "./KnowledgeContentContentSelector.vue?vue&type=template&id=5f83e4b6&scoped=true&"
import script from "./KnowledgeContentContentSelector.vue?vue&type=script&lang=js&"
export * from "./KnowledgeContentContentSelector.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeContentContentSelector.vue?vue&type=style&index=0&id=5f83e4b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f83e4b6",
  null
  
)

export default component.exports